import axios from 'axios';
import { useQuery, useQueryClient } from 'react-query';

import {
  deleteCurrentToken,
  useGetCurrentToken,
} from '~/hooks/auth/useGetCurrentToken';

export const useVerifyToken = (address, validPage) => {
  const { data: token } = useGetCurrentToken({
    address: address!,
    enabled: Boolean(address),
  }
  );
  const queryClient = useQueryClient();
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  return useQuery<any | undefined, Error>(
    ['verifyToken', token],
    async () =>
      new Promise((resolve) => {
        axios({
          url: `${apiHost}/auth/verify`,
          method: 'get',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => {
            resolve(res.status);
          })
          .catch((err) => {
            console.log('caught error', err);
            if (err?.response?.status === 401) {
              deleteCurrentToken(address);
              queryClient.invalidateQueries();
            }
            resolve(err.response.status);
          });
      }),
    {
      enabled: token !== undefined && !!address && validPage,
      staleTime: 60 * 1000,
    }
  );
};
